import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import 'jquery';
import 'popper.js';
import 'bootstrap/dist/js/bootstrap.js';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider, useGoogleLogin} from '@react-oauth/google';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';


const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const GCI = window.GoogleClientId;

ReactDOM.render(
            
<GoogleOAuthProvider clientId={GCI} >
        <BrowserRouter basename={baseUrl}>
            <App />
        </BrowserRouter>
    </GoogleOAuthProvider>,
    rootElement);

